import { axios, base } from '../http';

/** 协约币类型列表 */
export const getAgreementCoinTypes = (params) => {
  return axios.get(`${base}/api/AgreementCoin/GetCoinTypes`, { params });
};

/** 保存协约币类型 */
export const saveAgreementCoinTypes = (data) => {
  return axios.post(`${base}/api/AgreementCoin/SaveCoinTypes`, data);
};

/** 面值映射列表 */
export const getAgreementCoinFaceValueMaps = (params) => {
  return axios.get(`${base}/api/AgreementCoin/GetFaceValueMaps`, { params });
};

/** 保存面值映射 */
export const saveAgreementCoinFaceValueMaps = (data) => {
  return axios.post(`${base}/api/AgreementCoin/SaveFaceValueMaps`, data);
};

/** 每日币分上限 */
export const getAgreementCoinDailyScoreLimit = (params) => {
  return axios.get(`${base}/api/AgreementCoin/GetDailyScoreLimitConfig`, { params });
};

/** 保存每日币分上限 */
export const saveAgreementCoinDailyScoreLimit = (data) => {
  return axios.post(`${base}/api/AgreementCoin/SaveDailyScoreLimitConfig`, data);
};

/** 协约币汇总 */
export const getAgreementCoinSummary = (params) => {
  return axios.get(`${base}/api/AgreementCoin/GetSummary`, { params });
};

/** 协约币获得记录 */
export const getAgreementCoinRecords = (params) => {
  return axios.get(`${base}/api/AgreementCoin/GetRecords`, { params });
};

/** 协约币排行 */
export const getAgreementCoinRanking = (params) => {
  return axios.get(`${base}/api/AgreementCoin/GetRanking`, { params });
};

/** 导出协约币获得记录 */
export const exportAgreementCoinRecords = (params) => {
  return axios.get(`${base}/api/AgreementCoin/ExportRecords`, {
    params,
    responseType: 'blob',
  });
};

/** 导出协约币排行 */
export const exportAgreementCoinRanking = (params) => {
  return axios.get(`${base}/api/AgreementCoin/ExportRanking`, {
    params,
    responseType: 'blob',
  });
};

/** 撤销协约币 */
export const revokeAgreementCoin = (data) => {
  return axios.post(`${base}/api/AgreementCoin/Revoke`, data);
};
